import { modifyLinkBehavior } from '../utils.js';

export default function () {
  const widgetName = 'cardsWidget';
  const widgetOpts = cardsWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data) {
      const cards = $(`#${widgetName} .card-widget-item`);
      if (cards.length > 0) {
        modifyLinkBehavior(data, cards);
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 8,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
